import { render, staticRenderFns } from "./SupplierStadistics.vue?vue&type=template&id=4202cac4&scoped=true&"
import script from "./SupplierStadistics.vue?vue&type=script&lang=js&"
export * from "./SupplierStadistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4202cac4",
  null
  
)

export default component.exports